<template>
  <div
    ref="appWrapper"
    class="app-wrapper"
    style="height: auto; min-height: calc(100% - 44.8px);"
    :class="classObj"
  >
    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    ></div>
    <div
      v-if="sidebarAllowed"
      class="sidebar-container"
      :class="currentSTUModule === 'overview' ? 'sidebarless' : ''"
      :style="device !== 'mobile' ? 'top: 56px; ' : 'top: 80px;'"
    >
      <!-- <el-row class="rowTop2">
        <div
          v-if="sidebar.opened"
          style="display: flex; width: 100%; justify-content: flex-start; align-items: center; flex-direction: row;"
        >
          <span class="primaryTextColor" style="text-align: left; font-size: 14px;"
            >Hi, {{ username }}</span
          >
        </div>
      </el-row>
      <el-row class="rowTop3">
        <div
          v-if="sidebar.opened && companies.length > 1"
          style="display: flex; width: 100%; justify-content: center; align-items: flex-start; flex-direction: column; margin-top: 0px; margin-bottom: 10px;"
        >
          <el-button style="padding-top: 10px; padding-bottom: 10px;" @click="switchCompany()" type="dark" size="medium" round>
            <svg-icon icon-class="repeat_solid" style="margin-right: 5px;"/> Company
          </el-button>
        </div>
        <div style="display: flex; flex-direction: column; width: 100%; justify-content: center; align-items: center;" v-if="branchData">
          <span
            v-if="branchData.regionId && sidebar.opened"
            class="primaryTextColor"
            style="width: 100%; text-align: left; font-size: 20px; margin-bottom: 4px; margin-top: 0px;"
            >{{ branchData.regionId.companyId && branchData.regionId.companyId.name ? branchData.regionId.companyId.name : "-" }}</span
          >
          <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: center; margin-bottom: 20px;">
            <el-tag
              v-if="branchData.relation && sidebar.opened"
              type="lightfill"
              style="height: 100%; text-align: left; font-size: 14px; margin-top: 0px; padding: 4px; line-height: 14px;"
              >{{ branchData.relation.role | roleFilter }}</el-tag
            >
          </div>
        </div>
      </el-row> -->
      <el-row class="rowTop2">
        <div
          v-if="sidebar.opened"
          style="display: flex; flex-direction: column; width: 100%; justify-content: center; align-items: flex-start;"
        >
          <template v-if="branchData">
            <span 
              v-if="branchData.relation"
              class="primaryTextColor" style="text-align: left; font-size: 18px; font-weight: 700;"
            >
              {{ branchData.relation.role | roleFilter }}
            </span>
            <!-- <span
              v-if="mypetrolProfileData"
              class="primaryTextColor" style="text-align: left; font-size: 18px; font-weight: 700;"
            >
              {{ mypetrolProfileData.userGeneralName }}
            </span> -->
          </template>
        </div>
      </el-row>
      <sidebar></sidebar>
    </div>
    <div style="display: flex; flex-direction: column;" class="main-container" :class="currentSTUModule === 'overview' || sidebarAllowed === false ? 'sidebarless' : ''">
      <navbar></navbar>
      <app-main :nextBranch="nextBranch" :notificationSocket="notificationSocket" style="margin: 0px; flex: 1;"></app-main>
      <div class="footerClass">
        <div class="mySubsidiFooterContainer">
          <!-- <img :src="jata" class="appLogo"> -->
          <div style="display: flex; flex-direction: column; align-items: flex-start;">
            <span style="margin-bottom: 3px; margin-left: 15px;text-align: left; font-size: 16px; font-weight: bold;">KEMENTERIAN PERDAGANGAN DALAM NEGERI DAN KOS SARA HIDUP</span>
            <span style="margin-left: 15px;text-align: left; font-size: 14px">Hak Cipta Terpelihara © 2025-KPDN </span>
          </div>
        </div>
      </div>
      <!-- <div v-if="bossLoading" style="display: flex; width: 100%; position: absolute; top: 50px; justify-content: center; align-items: center;">
        <img style="display: flex; position: relative; width: 320px;" :src="boss"/>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from "./components";
import ResizeMixin from "@/mixin/ResizeHandler";
import SocketIO from 'socket.io-client'
import moment from 'moment'
import jata from '@/assets/jata.jpeg'

export default {
  name: "layout",
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  mixins: [ResizeMixin],
  props: {
    switchCompany: {
      type: Function
    },
    nextBranch: {
      type: Function
    },
    // notificationSocket: {
    //   type: Object
    // }
  },
  data() {
    return {
      notificationSocket: null,
      appname: process.env.APP_NAME,
      year: "",
      jata,
    };
  },
  mounted() {
    this.year = moment().format("YYYY");
    // console.log(this.$store.state.user.branchData)
    // console.log("layout")
    // this.nextBranch()
    // console.log('layout branchSelected', this.$store.state.app.branchSelected)
    // if (this.$store.state.app.branchSelected) {
    //   this.notificationSocket = SocketIO.connect(process.env.BASE_API, {
    //     path: '/serviceNotifications-admin-socket.io',
    //     query: `token=${this.token}`
    //   })
    //   this.notificationSocket.on('connect', () => {
    //     console.log('connected')
    //     this.notificationSocket.emit('join', this.$store.state.app.branchSelected)
    //   })
    //   this.notificationSocket.on('newNotification', (data) => {
    //     console.log('app', data)
    //     this.$store.dispatch('GetUnreadMessages', this.$store.state.app.branchSelected)
    //   })
    // }
  },
  destroyed() {
    this.notificationSocket.disconnect()
    this.$store.dispatch('EnableSidebarAllowed')
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    token() {
      return this.$store.state.user.token;
    },
    device() {
      return this.$store.state.app.device;
    },
    branchRole() {
      return this.$store.state.user.branchData && this.$store.state.user.branchData.relation && this.$store.state.user.branchData.relation.role ? this.$store.state.user.branchData.relation.role : null
    },
    branchData() {
      return this.$store.state.user.branchData
        ? this.$store.state.user.branchData
        : {};
    },
    mypetrolProfileData() {
      return this.$store.state.user.mypetrolProfileData
        ? this.$store.state.user.mypetrolProfileData
        : {};
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile"
      };
    },
    username() {
      return this.$store.state.user.username;
    },
    awakRole() {
      return this.$store.state.user.awakRole;
    },
    profilePicture() {
      return this.$store.state.user.profilePicture;
    },
    device() {
      return this.$store.state.app.device;
    },
    companies() {
      return this.$store.state.user.companies.sort((a, b) => {
        if (a.relationId && b.relationId) {
          if (a.relationId.name < b.relationId.name) {
            return -1
          }
          if (a.relationId.name > b.relationId.name) {
            return 1
          }
        }

        return 0
      });
    },
    currentSTUModule() {
      return this.$store.state.user.currentSTUModule
    },
    sidebarAllowed() {
      return this.$store.state.app.sidebarAllowed;
    },
  },
  filters: {
    roleFilter(val) {
      switch (val) {
        case 'kpdnadmin':
          return 'Admin'
        case 'ministryuser':
          return 'Ministri'
        case 'agencyuser':
          return 'Agensi'
        case 'oilcompanyuser':
          return 'Syarikat Minyak'
        case 'enforcer':
          return 'Bahagian Penguatkuasa'
        case 'Owner':
          return 'Pengguna'
        case 'cawanganuser':
          return 'Cawangan'
        case 'callcenteruser':
          return 'Call Center'
        case 'stateuser':
          return ''
        case 'bpmuser':
          return 'BPM'
        case 'unregistereduser':
          return 'Unregistered'
        default:
          return val
      }
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("CloseSideBar", { withoutAnimation: false });
    },
    legal() {
      window.open('/legal')
    },
    privacy() {
      window.open('/privacy')
    },
    cookie() {
      window.open('/cookie')
    },
  }
};
</script>

<style lang="scss">
body {
  background-color: var(--bg-color);
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/variables.scss";
@import "src/styles/mixin.scss";
.app-wrapper {
  color: var(--primary-color);
  @include clearfix;
  overflow: scroll;
  scroll-behavior: smooth;
  position: relative;
  width: 100%;
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
.rowTop2 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  padding-left: 20px;
  padding-right: 40px;
  padding-top: 30px;
  padding-bottom: 10px;
  background-color: var(--bg-color);
}
.rowTop3 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding-left: 40px;
  padding-right: 20px;
  // height: 108px;
  background-color: var(--bg-color);
}
</style>


// WEBPACK FOOTER //
// src/views/admin/layout/Layout.vue